import React from 'react';
import theme from '@theme';

interface ErrorIconProps {
  background?: string;
  contrast?: string;
}

const ErrorIcon = ({
  background = theme.palette.common.white,
  contrast = (theme.palette.error as any).contrastMain,
}: ErrorIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill={contrast} />
    <path
      d="M10.6875 13.9791V5.52081H13.3125V13.9791H10.6875ZM10.6875 18.4791V15.8541H13.3125V18.4791H10.6875Z"
      fill={background}
    />
  </svg>
);

export default ErrorIcon;
